// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"882487c2","266":"082a8098","676":"94426917"}[chunkId] + ".chunk.js";
};